jQuery(document).ready(function($) {
	
	var search = $(".recipes-search");

	search.on('click', '.filter', function(event) {
		
		/**/
		$(this).closest('.recipes-search').addClass('filter-active');

	});

	search.on('click', '.filter-close', function(event) {
		
		/**/
		$(this).closest('.recipes-search').removeClass('filter-active');

	});

});